import React from "react";
import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";
import { generateObjectId } from "../../../utils/objectIdUtils";
import { AddAndDeleteInlineIcon } from "../../../components/BuilderComponents/Preview/IconPreview";

export default function SectionTabs({ activeTab, sectionsTabs, onChange, onTabClick, onDeleteTab }) {
  const getNextId = () => {
    if (!sectionsTabs || sectionsTabs.length === 0) return 1;
    return sectionsTabs.length + 1;
  };

  const addNewTab = () => {
    const nextId = getNextId();
    const newTab = {
      id: generateObjectId(),
      name: `Section ${nextId}`,
      icon: ""
    };
    const newSections = [...sectionsTabs, newTab];
    onChange(newSections);
    onTabClick(newTab.id);
  };

  const updateTabName = (id, newName) => {
    const updatedSections = sectionsTabs.map((section) =>
      section.id === id ? { ...section, name: newName } : section
    );
    onChange(updatedSections);
  };

  const updateTabIcon = (id, newIcon) => {
    const updatedSections = sectionsTabs.map((section) =>
      section.id === id ? { ...section, icon: newIcon } : section
    );
    onChange(updatedSections);
  };

  return (
    <div style={{ width: "100%", borderBottom: "1px solid #e5e7eb" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
        {/* Add New Tab Button */}
        {sectionsTabs?.length >= 1 && (
          <button
            onClick={addNewTab}
            style={{
              width: "32px",
              height: "32px",
              backgroundColor: "transparent",
              border: "none",
              cursor: "pointer",
              color: "#6b7280",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
            onMouseOver={(e) => (e.target.style.color = "#374151")}
            onMouseOut={(e) => (e.target.style.color = "#6b7280")}
          >
            <MaterialIcon name="add" />
          </button>
        )}

        {/* Existing Tabs */}
        {sectionsTabs.map((section) => (
          <div
            key={section.id}
            style={{
              display: "flex",
              alignItems: "center",
              padding: "8px 12px",
              backgroundColor: activeTab === section.id ? "#f8fafc" : "transparent",
              borderBottom: activeTab === section.id ? "2px solid var(--builder-primary)" : "2px solid transparent",
              cursor: "pointer"
            }}
            onClick={() => onTabClick(section.id)}
          >
            <div className="d_flex align_center" style={{ gap: "4px" }}>
              <AddAndDeleteInlineIcon
                icon={section.icon}
                callbackFunction={(newIcon) => updateTabIcon(section.id, newIcon)}
              />
              <input
                type="text"
                value={section.name}
                onChange={(e) => updateTabName(section.id, e.target.value)}
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  outline: "none",
                  fontSize: "14px",
                  color: activeTab === section.id ? "#111827" : "#6b7280",
                  fontWeight: activeTab === section.id ? "500" : "400",
                  width: "80px"
                }}
              />
            </div>
            {sectionsTabs.length > 1 && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onDeleteTab(section.id);
                }}
                style={{
                  marginLeft: "4px",
                  color: "#9ca3af",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  width: "16px",
                  height: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
                onMouseOver={(e) => (e.target.style.color = "#ef4444")}
                onMouseOut={(e) => (e.target.style.color = "#9ca3af")}
              >
                <MaterialIcon name="close" />
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
